import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { ISocialiteUser } from "../types/user";

const baseKey = ["socialite-users"];
export const connectedAccountsService = {
	baseKey,
	all: () => axios.get<LaravelResponse<ISocialiteUser[]>>(keyToUrl(baseKey)),
};
